import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen {
    .to-print {
      display: none;
    }
  }

  .card {
    padding: 16px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    position: relative;

    -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);

    h3 {
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 8px;
      text-decoration: underline;
    }

    p {
      font-size: 14px;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    strong {
      font-size: 14px;
      font-weight: 600;
    }
  }
`

export const DetailsHead = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;

  @media (max-width: 800px) {
    width: 100%;
    flex-direction: column;
  }
`

export const DetailsWrapper = styled.div`
  width: 50%;

  .status {
    display: flex;
  }

  @media (max-width: 800px) {
    width: 100%;
  }
`
export const Tag = styled.div`
  ${({ theme, color, type }) => css`
    padding: 2px 4px;
    font-size: 13px;
    border-radius: 4px;
    color: #fff;
    font-weight: 600;
    max-height: 20px;
    margin-left: 8px;

    ${color === 'green' &&
    css`
      background-color: #27ae60;
    `}

    ${color === 'red' &&
    css`
      background-color: #fa3434;
    `}

    ${type === 'Negociação aguardando avaliação' ||
    type === 'Em Avaliação' ||
    type === 'Cotação com Pedido'
      ? css`
          color: #ffffff;
          background: ${theme.colors.alert};
        `
      : null}

    ${type === 'Negociação Avaliada' || type === 'Avaliada'
      ? css`
          color: #ffffff;
          background: ${theme.colors.success};
        `
      : null}

    ${type === 'Cancelada' &&
    css`
      color: #ffffff;
      background: ${theme.colors.error};
    `}

    ${type === 'Vencida' &&
    css`
      color: #ffffff;
      background: ${theme.colors.error};
    `}

    ${type === 'Cotação' ||
    type === 'Cotação com Pedido' ||
    type === 'Negociação com Pedido' ||
    type === 'Convertida'
      ? css`
          color: #ffffff;
          background: #afaeae;
        `
      : null}

    ${type === 'waiting' &&
    css`
      display: none;
    `}

    ${type === null &&
    css`
      display: none;
    `}
  `}
`

export const AddressPaymentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 8px;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const AddressPaymentItem = styled.div`
  .pagamento {
    display: flex;

    img {
      width: 30px;
      margin-right: 8px;
      margin-left: -4px;
    }
  }
`

export const Delivery = styled.div`
  hr {
    opacity: 0.3;
    margin-bottom: 16px;
  }

  .pedido-head {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    div {
      max-height: 24px;
      /* position: static;
      height: 100%; */
      position: unset;
    }
  }

  .data-entrega {
    margin-top: 30px;
    text-align: right;
  }

  .nota-fiscal {
    display: flex;
    justify-content: flex-end;
  }

  .produtos {
    display: flex;
    flex-wrap: wrap;
    p {
      margin-bottom: 0;
    }
  }
`

export const DetailsFooter = styled.div`
  display: flex;
  margin-bottom: 16px;
  gap: 16px;

  @media (max-width: 1024px) {
    justify-content: space-between;
  }

  @media screen {
    .to-print {
      display: none;
    }
  }
`

export const Button = styled.button`
  ${({ theme }) => css`
    padding: 10px 16px;
    border-radius: 4px;
    text-wrap: nowrap;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    background: #d22630;
    border: 2px solid #d22630;
    color: #fff;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all ease-in-out 400ms;

    &:hover {
      background: #a71e26;
      border: 2px solid #a71e26;
    }

    img {
      margin-right: 12px;
    }

    &.outline-green {
      background: transparent;
      color: #27ae60;
      border: 2px solid #27ae60;
    }

    &.outline-red {
      background: transparent;
      color: #d22630;
      border: 2px solid #d22630;
    }

    &.outline-red:hover {
      border: 2px solid #a71e26;
    }

  
    &.outline {
      background: transparent;
      color: #707070;
      border: 2px solid #707070;
      @media (max-width: 1024px) {
        width: 45vw;
      }
    }

    &.green {
      background: #27ae60;
      border: 2px solid #27ae60;
      @media (max-width: 1024px) {
        width: 45vw;
      }

      @media (max-width: 480px) {
        font-size: 13px;
      }

    &.green:hover {
      background: #07bc0c;
    }
  `}
`
